import React from 'react';
import SubContext from './SubContext';
import { getUserEmail } from '../user.utilities';
import { API } from '../API';
import PropTypes from 'prop-types';

const SubContainer = ({ children }) => {
  const [subs, setSubs] = React.useState([]);
  const [userRole, setRole] = React.useState(null);
  const [selectedSub, setSelectedSub] = React.useState(null);

  React.useEffect(() => {
    let subListCall = [];

    getUserEmail().then((email) => {
      API.get(`/get?login=${email}`)
        .then((res) => {
          subListCall = res.data.subscribers;

          setSubs(subListCall);
          setRole(res.data.role);

          if (subListCall.length === 1) {
            setSelectedSub(subListCall[0]);
          }
        })
        .catch((err) => console.log(err));
    });
  }, []);

  return (
    <SubContext.Provider
      value={{ subs, selectedSub, setSelectedSub, userRole }}
    >
      {children}
    </SubContext.Provider>
  );
};

SubContainer.propTypes = {
  children: PropTypes.any,
};

export default SubContainer;
